const AUTH_PATHS = new Set(["/sign-in", "/sign-up"]);

export function oauthErrorCallbackUrl(callbackURL: string | undefined) {
    const redirect = sanitizeAuthRedirectUrl(callbackURL);
    return redirect && redirect !== "/"
        ? `/sign-in?error=oauth&redirect_url=${encodeURIComponent(redirect)}`
        : "/sign-in?error=oauth";
}

export function sanitizeAuthRedirectUrl(
    redirectTo: string | string[] | null | undefined,
): string | undefined {
    if (typeof redirectTo !== "string") return undefined;
    const trimmed = redirectTo.trim();
    if (!trimmed) return undefined;

    let value = trimmed;
    if (/^https?:\/\//iu.test(trimmed)) {
        try {
            const url = new URL(trimmed);
            value = `${url.pathname}${url.search}${url.hash}`;
        } catch {
            return undefined;
        }
    }
    if (
        !value.startsWith("/") ||
        value.startsWith("//") ||
        value.startsWith("/\\")
    ) {
        return undefined;
    }
    let decoded: string;
    try {
        decoded = decodeURIComponent(value);
    } catch {
        return undefined;
    }
    if (
        decoded.startsWith("//") ||
        decoded.startsWith("/\\") ||
        /^\/[\t\n\r /\\]/u.test(decoded)
    ) {
        return undefined;
    }
    const path = (value.split(/[?#]/u)[0] ?? "").replace(/\/+$/u, "") || "/";
    if (
        AUTH_PATHS.has(path) ||
        path.startsWith("/sign-in/") ||
        path.startsWith("/sign-up/")
    ) {
        return undefined;
    }
    return value;
}
